import { NgModule } from '@angular/core';
import { ApplicationLayoutComponent } from './application-layout/application-layout.component';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule, LabelModule, SvgIconModule } from '@lancomsystems/ui-kit-lib';

@NgModule({
  declarations: [
    HeaderComponent,
    ApplicationLayoutComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,

    LabelModule,
    ButtonModule,
    SvgIconModule,
  ],
  exports: [
    ApplicationLayoutComponent,
  ],
})
export class LayoutsModule {
}
